import CryptoJS from "crypto-js";

const secretKey = "hogistTicket123456";

// Encrypt text
export function encryptText(text) {
  const encrypted = CryptoJS.AES.encrypt(text, secretKey).toString();
  return encrypted;
}

// Decrypt text with validation
export function decryptText(encryptedText) {
  if (!encryptedText || typeof encryptedText !== 'string') {
    console.error("Invalid encrypted text provided.");
    return null;  // or handle this case accordingly
  }

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedText, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    // If the result is an empty string, the decryption failed (could be due to incorrect input or key)
    if (!decrypted) {
      console.error("Decryption failed: the result is empty.");
      return null;  // or handle this case accordingly
    }

    return decrypted;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
}
